import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { CLE_MOTIF } from '../components/ExpirationSession';
import useEstMobile from '../hooks/useEstMobile';
import { ROLES_ACTEUR, ROLES_DEMANDEUR } from '../constants/roles';

import {
  IconeHorloge, IconeCadenas, IconeOeil, IconeValide,
} from '../components/IconesSVG';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, loading, error } = useAuthStore();
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const estMobile = useEstMobile();
  const [showPwd, setShowPwd] = useState(false);
  // Motif depose par la surveillance d'inactivite. Lu une seule fois : sans
  // cela le message reapparaitrait a chaque retour sur la page.
  const [motifDeconnexion] = useState(() => {
    const motif = sessionStorage.getItem(CLE_MOTIF);
    if (motif) sessionStorage.removeItem(CLE_MOTIF);
    return motif;
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = await login(email, motDePasse);
      const role = user?.roles?.[0]?.role || user?.role;
      if (user?.isGlobal || role === 'admin') navigate('/dashboard');
      if (role === 'pdg') navigate('/parapheur');
      else if (ROLES_ACTEUR.includes(role)) navigate('/dashboard-acteur');
      else if (ROLES_DEMANDEUR.includes(role)) navigate('/dashboard-demandeur');
      else navigate('/dashboard');
    } catch { }
  };

  return (
    <div style={estMobile ? { ...s.wrap, flexDirection: 'column' } : s.wrap}>

      {/* ===================== PANNEAU GAUCHE ===================== */}
      <div style={estMobile ? { ...s.left, display: 'none' } : s.left}>

        {/* Documents flottants décoratifs */}
        <div style={{ position: 'absolute', right: -20, top: 60, width: 140, background: 'rgba(255,255,255,0.04)', border: '0.5px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 12, transform: 'rotate(8deg)', zIndex: 0 }}>
          <div style={{ height: 6, background: 'rgba(192,57,43,0.5)', borderRadius: 3, marginBottom: 6, width: '70%' }} />
          <div style={{ height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 2, marginBottom: 4 }} />
          <div style={{ height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 2, marginBottom: 4, width: '80%' }} />
          <div style={{ height: 4, background: 'rgba(255,255,255,0.06)', borderRadius: 2, width: '60%' }} />
          <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 16, height: 16, borderRadius: '50%', background: '#27AE60', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, color: '#fff', fontWeight: 700 }}><IconeValide taille={9} /></div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)' }}>Approuvé · DG</div>
          </div>
        </div>

        <div style={{ position: 'absolute', right: 30, top: 210, width: 120, background: 'rgba(255,255,255,0.03)', border: '0.5px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: 10, transform: 'rotate(-5deg)', zIndex: 0 }}>
          <div style={{ height: 5, background: 'rgba(41,128,185,0.4)', borderRadius: 3, marginBottom: 5, width: '80%' }} />
          <div style={{ height: 3, background: 'rgba(255,255,255,0.08)', borderRadius: 2, marginBottom: 3 }} />
          <div style={{ height: 3, background: 'rgba(255,255,255,0.08)', borderRadius: 2, width: '70%' }} />
          <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 5 }}>
            <div style={{ width: 14, height: 14, borderRadius: '50%', background: '#2980B9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 7, color: '#fff', fontWeight: 700 }}>→</div>
            <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.25)' }}>En cours</div>
          </div>
        </div>

        <div style={{ position: 'absolute', right: -10, top: 380, width: 110, background: 'rgba(255,255,255,0.02)', border: '0.5px solid rgba(255,255,255,0.05)', borderRadius: 10, padding: 10, transform: 'rotate(3deg)', zIndex: 0 }}>
          <div style={{ height: 5, background: 'rgba(142,68,173,0.3)', borderRadius: 3, marginBottom: 5 }} />
          <div style={{ height: 3, background: 'rgba(255,255,255,0.06)', borderRadius: 2, marginBottom: 3 }} />
          <div style={{ height: 3, background: 'rgba(255,255,255,0.06)', borderRadius: 2, width: '60%' }} />
          <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 5 }}>
            <div style={{ width: 14, height: 14, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 7, color: 'rgba(255,255,255,0.3)', fontWeight: 700 }}>·</div>
            <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.2)' }}>En attente</div>
          </div>
        </div>

        <div style={s.leftContent}>

          {/* LOGO */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 52 }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 166 165" width="72" height="72">
              <path d="M78 5L86 5L92 8L113 30L75 30L64 34L56 41L49 53L30 114L8 93L5 88L5 78L7 74L36 44L72 8L77 6Z M74 34L142 34L126 47L127 48L131 47L154 70L159 77L159 88L157 92L125 125L90 159L80 161L73 158L38 123L99 123L104 122L113 117L121 108L125 100L136 68L134 66L89 66L85 72L80 88L81 89L106 89L103 93L98 95L61 95L61 93L70 66L76 58L79 57L115 57L119 54L118 53L77 53L72 56L67 64L57 95L58 99L99 99L107 93L109 87L108 86L83 86L87 76L87 73L89 70L113 70L114 72L115 70L131 70L131 73L123 97L117 108L112 113L101 118L35 118L34 117L54 53L57 47L63 40L67 37L73 35Z" fill="#D01020" />
              <path d="M74 34L142 34L142 35L118 53L77 53L72 56L68 60L69 61L63 76L57 98L55 100L56 101L36 115L35 117L34 115L41 96L41 93L54 53L57 47L63 40L67 37L73 35Z" fill="#40B030" />
              <path d="M89 70L113 70L114 72L115 70L131 70L131 73L123 97L117 108L109 115L101 118L35 118L34 117L35 118L36 116L56 102L57 99L99 99L104 96L109 89L108 86L83 86L88 71Z" fill="#1070B0" />
            </svg>
            <div>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#fff', letterSpacing: '-0.5px', lineHeight: 1 }}>JETA GED</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 5, letterSpacing: '0.06em' }}>GESTION ÉLECTRONIQUE DES DOCUMENTS</div>
            </div>
          </div>

          {/* MESSAGE */}
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontSize: 36, fontWeight: 800, color: '#fff', lineHeight: 1.15, letterSpacing: '-0.8px', marginBottom: 14 }}>
              Chaque document<br/>a son chemin.
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.7 }}>
              De la demande terrain jusqu'à<br/>la signature du PDG.
            </div>
          </div>

          {/* SEPARATEUR */}
          <div style={{ height: '0.5px', background: 'rgba(255,255,255,0.08)', marginBottom: 28 }} />

          {/* STATS */}
          <div style={{ display: 'flex', gap: 24 }}>
            <div>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#C0392B', lineHeight: 1 }}>7</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 4 }}>Filiales</div>
            </div>
            <div style={{ width: '0.5px', background: 'rgba(255,255,255,0.08)' }} />
            <div>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#27AE60', lineHeight: 1 }}>8</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 4 }}>Étapes validées</div>
            </div>
            <div style={{ width: '0.5px', background: 'rgba(255,255,255,0.08)' }} />
            <div>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#3498DB', lineHeight: 1 }}>100%</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 4 }}>Traçabilité</div>
            </div>
          </div>

          {/* COPYRIGHT */}
          <div style={{ position: 'absolute', bottom: 28, left: 52, fontSize: 10, color: 'rgba(255,255,255,0.15)', letterSpacing: '0.04em' }}>
            © 2026 JETA Groupe · Gabon
          </div>

        </div>
      </div>

      {/* ===================== PANNEAU DROIT ===================== */}
      <div style={estMobile ? { ...s.right, width: '100%', padding: '24px 18px', minHeight: '100vh' } : s.right}>
        <div style={estMobile ? { ...s.card, width: '100%', maxWidth: '100%', minWidth: 0 } : s.card}>
          <div style={s.portailBadge}>PORTAIL GED</div>
          <div style={s.cardTitle}>Bienvenue</div>
          <div style={s.cardSub}>Connectez-vous pour accéder à votre espace</div>

          {motifDeconnexion && (
            <div style={{ background: '#FEF9E7', border: '1px solid #F1C40F', color: '#9A7D0A', borderRadius: 8, padding: '10px 12px', fontSize: 12.5, marginBottom: 12 }}>
              <IconeHorloge taille={13} /> {motifDeconnexion}
            </div>
          )}
          {error && <div style={s.errorBox}>{error}</div>}

          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <div style={s.fieldGroup}>
              <label style={s.label}>Identifiant ou Email</label>
              <div style={s.inputWrap}>
                <span style={s.inputIcon}>@</span>
                <input
                  style={s.input}
                  type="text"
                  placeholder="Ex: lrc-001"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>
            </div>

            <div style={s.fieldGroup}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <label style={s.label}>Mot de passe</label>
                <span style={s.forgotLink}>Mot de passe oublié ?</span>
              </div>
              <div style={s.inputWrap}>
                <span style={s.inputIcon}><IconeCadenas taille={14} /></span>
                <input
                  style={s.input}
                  type={showPwd ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={motDePasse}
                  onChange={e => setMotDePasse(e.target.value)}
                  autoComplete="current-password"
                  required
                />
                <button type="button" onClick={() => setShowPwd(!showPwd)} style={s.eyeBtn}>
                  <IconeOeil taille={15} />
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={{ ...s.btnSubmit, opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Connexion...' : 'Se connecter →'}
            </button>
          </form>

          <div style={s.divider}><span>ou</span></div>

          <button style={s.btnWhatsapp}>
            <span />
            Recevoir un code par WhatsApp
          </button>

          <div style={s.footerNote}><IconeCadenas taille={11} /> Accès réservé aux employés JETA Groupe</div>
        </div>
      </div>

    </div>
  );
}

const s = {
  wrap: { display: 'flex', minHeight: '100vh', fontFamily: 'Inter, system-ui, sans-serif' },

  // GAUCHE
  left: {
    width: '55%',
    background: '#111827',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftContent: {
    position: 'relative',
    zIndex: 1,
    padding: '48px 52px',
    width: '100%',
    maxWidth: 520,
  },

  // DROITE
  right: {
    width: '45%',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 32px',
  },
  card: {
    width: '100%',
    maxWidth: 380,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  portailBadge: {
    fontSize: 11,
    fontWeight: 700,
    color: '#C0392B',
    letterSpacing: '0.1em',
    marginBottom: 12,
  },
  cardTitle: {
    fontSize: 32,
    fontWeight: 800,
    color: '#0D1B2A',
    marginBottom: 8,
    letterSpacing: '-0.5px',
  },
  cardSub: {
    fontSize: 14,
    color: '#888',
    marginBottom: 32,
    lineHeight: 1.5,
  },
  errorBox: {
    background: '#FDEDEC',
    border: '0.5px solid #E74C3C',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 13,
    color: '#96281B',
    marginBottom: 16,
    width: '100%',
    boxSizing: 'border-box',
  },
  fieldGroup: { width: '100%', marginBottom: 20 },
  label: { fontSize: 13, fontWeight: 600, color: '#333', display: 'block', marginBottom: 6 },
  inputWrap: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    background: '#FAFAFA',
    padding: '0 12px',
    gap: 8,
  },
  inputIcon: { fontSize: 14, color: '#aaa', flexShrink: 0 },
  input: {
    flex: 1,
    padding: '12px 0',
    border: 'none',
    background: 'transparent',
    fontSize: 14,
    color: '#0D1B2A',
    outline: 'none',
    fontFamily: 'inherit',
  },
  eyeBtn: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    padding: 0,
    flexShrink: 0,
  },
  forgotLink: {
    fontSize: 12,
    color: '#C0392B',
    cursor: 'pointer',
    fontWeight: 500,
  },
  btnSubmit: {
    width: '100%',
    padding: '14px',
    borderRadius: 10,
    border: 'none',
    background: '#C0392B',
    color: '#fff',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
    marginTop: 4,
    letterSpacing: '-0.2px',
  },
  divider: {
    width: '100%',
    textAlign: 'center',
    margin: '20px 0',
    position: 'relative',
    fontSize: 12,
    color: '#bbb',
  },
  btnWhatsapp: {
    width: '100%',
    padding: '12px',
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    background: '#fff',
    fontSize: 14,
    color: '#333',
    cursor: 'pointer',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    fontWeight: 500,
  },
  footerNote: {
    marginTop: 24,
    fontSize: 12,
    color: '#aaa',
    textAlign: 'center',
    width: '100%',
  },
};
